import type { RouteLocationNormalizedLoaded } from 'vue-router';
import { isArticlePage, isHealthPath, isListAllPage } from '~/utils/router';

export default defineNuxtRouteMiddleware((to) => {
  const nuxtError = useError();
  if (import.meta.client) return;
  if (nuxtError.value) return;
  if (!calcNeed404Error(to)) return;

  const { $logger } = useNuxtApp();
  const log = $logger.withScope('🛑️ error 404');
  log({ url: to.fullPath, error: nuxtError.value });

  return abortNavigation(
    createError({
      statusCode: 404,
      statusMessage: 'wrong url from error404 middleware',
    }),
  );
});

function calcNeed404Error(route: RouteLocationNormalizedLoaded) {
  let needError = false;

  // При открытии статьи с добавление любых символов к слагу отдавать 404 (LH-1373)
  if (isArticlePage(route.name as string)) {
    const notDateUrlPattern = /\/\d{4}\/\d{1,2}\/\d{1,2}(\/.*)/g;

    // В здоровье может быть 3 части в URL eg /health/kachestvo-zhizni/testovaya-statya/
    // В обычных статья только 1 /:slug/
    const maxParts = isHealthPath(route.path) ? 3 : 1;

    // Получаем все не пустые части URL между слэшами
    const parts = route.path.split('/').filter(Boolean).length;

    if (!notDateUrlPattern.test(route.path) && parts > maxParts) {
      needError = true;
    }
  }

  if (isListAllPage(route.name as string)) {
    // WP_ADMIN-448 404 для ссылок формата /list/.+
    const incorrectListPagePattern = /list\/.+/gm;
    if (incorrectListPagePattern.test(route.path)) {
      needError = true;
    }
  }

  try {
    decodeURIComponent(route.path);
  } catch {
    needError = true;
  }

  return needError;
}
